import React, { memo, useState } from "react";
import useDidMountEffect from "../../hooks/useDidMountEffect";

//  Component starts
const SearchBox = ({ search = () => {}, searchValue }) => {
	const [searchedVal, setSearchedVal] = useState(searchValue);

	useDidMountEffect(() => {
		const timer = setTimeout(() => search(searchedVal), 500);
		return () => clearTimeout(timer);
	}, [searchedVal]);

	return (
		<div className="search position-relative has-icon-left">
			<input
				type="search"
				className="form-control text-none"
				placeholder="Search"
				value={searchedVal}
				onChange={(e) => {
					setSearchedVal(e.target.value);
				}}
			/>
			<div className="form-control-position">
				<span className="bx bx-search"></span>
			</div>
		</div>
	);
};

export default memo(SearchBox);
